export const setUser = (user) => { return { type: 'SET_USER', payload: user } }
export const setIsAuth = (isAuth) => { return { type: 'SET_IS_AUTH', payload: isAuth } }
export const logout = () => { return { type: 'LOGOUT' } }